import { useNavigate } from "react-router-dom";
import { ArrowRight, Lock } from "lucide-react";

export default function SendLimitBanner({ remaining, total, limitReached }) {
  const navigate = useNavigate();

  if (!limitReached && remaining > 0) return null;

  return (
    <div
      className="bg-zinc-900 border-b border-zinc-800 px-4 sm:px-6 py-2.5 flex items-center justify-between gap-3"
      data-testid="send-limit-banner"
    >
      <div className="flex items-center gap-2 min-w-0">
        <Lock size={15} className="text-zinc-500 shrink-0" />
        <span className="text-sm text-zinc-200 font-medium">
          You've reached your free send limit.
        </span>
      </div>
      <button
        onClick={() => navigate("/pricing")}
        className="shrink-0 flex items-center gap-1.5 px-4 py-1.5 rounded-md text-xs font-semibold bg-white text-[#111111] hover:bg-[#F5F5F5] transition-colors"
        data-testid="send-limit-upgrade-button"
      >
        Upgrade to send more emails
        <ArrowRight size={14} />
      </button>
    </div>
  );
}
